// firebaseConfig.ts
const firebaseConfig = {
  apiKey: 'AIzaSyDJqDfPFserhVQwicRBXMQYccz-darDe_4',
  authDomain: 'as3-app.firebaseapp.com',
  projectId: 'as3-app',
  storageBucket: 'as3-app.appspot.com',
  messagingSenderId: '985516052382',
  appId: '1:985516052382:web:c6411f69862867a521908f',
  measurementId: 'G-9REC7KCXXD'
}

export { firebaseConfig }
